<template>
  <div class="custom-info-set-detail">
    <div class="title">
      <span>{{ pageTitle }} 模板设置：</span>
      <span class="btn-like" @click="showPopup = true">快捷设置</span>
    </div>
    <div class="card card-base">
      <van-cell>
        <template #title>
          <span class="card-title">基础信息</span>
        </template>
      </van-cell>
      <van-cell
        v-for="item in baseList"
        :key="item.fieldCode"
        :title="item.fieldName"
        :isLink="!item.isFixed"
        arrow-direction="down"
        @click="setDisplay(item)"
      >
        <!-- <span :class="{ 'right-text': item.isFixed }">
          {{ statusText(item) }}
        </span> -->
      </van-cell>
    </div>

    <div class="card">
      <van-cell>
        <template #title>
          <div class="flex-between">
            <span class="card-title"> 自定义信息 </span>
            <span class="btn-like" @click="$router.push(`/studentFieldSet?type=${$route.params.type}`)" v-if="app.permission.op('queryCustomField || addCustomField || editCustomField || deleteCustomField')">设置</span>
          </div>
        </template>
      </van-cell>
      <van-cell
        v-for="item in customList"
        :key="item.fieldCode"
        :title="item.fieldName"
        isLink
        arrow-direction="down"
        @click="setDisplay(item)"
      >
        <span>
          {{ statusText(item) }}
        </span>
      </van-cell>
    </div>

    <van-action-sheet
      v-model="displayShow"
      :actions="displayActions"
      cancel-text="取消"
      close-on-click-action
      @select="onDisplaySelect"
    />

    <van-action-sheet v-model="showPopup" cancel-text="取消" close-on-click-action>
      <div class="custom-info-set-detail-show-popup">
        <div
          class="cell"
          v-for="item in menuList"
          :key="item.key"
          @click="applySetting(item)"
        >
          快捷获取 <span class="main-text">{{ item.text }}</span> 的设置
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
const businessTypeMap = {
  STUDENT_OFFICIALLY: '老师录入学员',
  STUDENT_INTENTION: '老师录入意向',
  STUDENT_RECRUITS: '招生码录入意向',
  STUDENT_OFFICIALLY_SELF: '商城自助购买登记学员',
};
const quickTypeList = {
  STUDENT_OFFICIALLY: [
    {
      key: 'STUDENT_OFFICIALLY_SELF',
      text : '商城自助购买登记学员'
    }
  ],
  STUDENT_OFFICIALLY_SELF: [
    {
      key: 'STUDENT_OFFICIALLY',
      text : '老师录入学员'
    }
  ],
  STUDENT_RECRUITS: [
    {
      key: 'STUDENT_INTENTION',
      text : '老师录入意向'
    }
  ],
  STUDENT_INTENTION: [
    {
      key: 'STUDENT_RECRUITS',
      text : '招生码录入意向'
    }
  ]
}


export default {
  name: 'custom-info-set-detail',
  data() {
    const menuList = quickTypeList[this.$route.params.type];
    return {
      pageTitle: businessTypeMap[this.$route.params.type],
      baseList: [],
      businessType: this.$route.params.type,
      customList: [],
      displayActions: [
        { id: 0, name: '不展示' },
        { id: 1, name: '非必填' },
        { id: 2, name: '必填' },
      ],
      displayShow: false,
      menuList,
      showPopup: false,
    };
  },
  methods: {
    statusText(item) {
      const obj = item.displayList[0];
      if (obj.display === 0) {
        return '不展示';
      } else if (obj.required) {
        return '必填';
      } else {
        return '非必填';
      }
    },

    async setDisplay(item) {
      if (item.isFixed){
        return;
      }
      this.displayShow = true;
      const ret = await new Promise(resolve => {
        this._display_resolve = resolve;
      });
      this.showLoading();
      await this.$api.postCustomFieldDisplay({
        customFieldId: item.id,
        businessType: this.businessType,
        display: ret.id,
        type: item.type,
        fieldCode: item.fieldCode,
      });
      vant.Toast.clear();
      if (ret.id === 0) {
        item.displayList[0].display = 0;
      } else if (ret.id === 1) {
        item.displayList[0].display = 1;
        item.displayList[0].required = 0;
      } else if (ret.id === 2) {
        item.displayList[0].display = 1;
        item.displayList[0].required = 1;
      }
    },
    onDisplaySelect(item) {
      this._display_resolve(item);
    },
    async applySetting(item) {
      this.showLoading();
      const res = await this.$api.getCustomFieldList({
        classify: 'STUDENT',
        businessType: item.key,
      });
      const list = res.data.map(item => ({
        businessType: this.businessType,
        customFieldId: item.id,
        display: item.displayList[0].display + item.displayList[0].required,
        fieldCode: item.fieldCode,
        type: item.type,
      }));
      await this.$api.postCustomFieldDisplayBatch({
        updateDisplayRos: list,
      });
      vant.Toast.clear();
      const menus = quickTypeList[this.$route.params.type];
      vant.Toast.success(`同步 ${menus[0].text} 的设置成功`);
      this.showPopup = false;
      this.render();
    },
    render() {
      this.$api
        .getCustomFieldList({
          classify: 'STUDENT',
          businessType: this.businessType,
          containBase: 1,
        })
        .then(res => {
          this.baseList = res.data.filter(item => item.type === 1);
          this.customList = res.data.filter(item => item.type === 2);
          if (this.businessType === 'STUDENT_OFFICIALLY_SELF') {
            this.customList = this.customList.filter(item => item.fieldCode !== 'come_from');
          }

        });
    },
  },
  async created() {
    this.render();
    this.$onBus('student-field-addOrEdit-success', () => this.render());
  },
};
</script>

<style lang="scss" scoped>
.custom-info-set-detail {
  .title {
    padding: calc(var(--gap) * 16);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    color: var(--g6);
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-like {
    color: var(--c1);
    padding-left: calc(var(--gap) * 16);
  }
  .card {
    background: var(--white);
    margin-bottom: calc(var(--gap) * 12);
    .card-title {
      color: var(--g8);
      font-weight: var(--bold);
    }
    .right-text {
      color: var(--g6);
    }
  }
}
</style>

<style lang="scss">
.custom-info-set-detail-show-popup {
  padding: calc(var(--gap) * 16);
  overflow: auto;
  color: var(--g8);
  > .cell {
    padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    text-align: center;
    .main-text {
      color: var(--c1);
    }
  }
}
</style>